import React, { ReactNode } from 'react';

import cx from 'classnames';
import { Tooltip } from 'antd';

import { ReactComponent as LockIcon } from '../../../../assets/sightx-icons/svg/sx-lock.svg';
import { LapsedTooltipText, UpgradeTooltipText } from '../../accessControl';
import { tooltipMessage } from '../../../../slices/auth/authSelectors';
import { Features, isFeatureEnabled } from '../../../../featureToggles/features';

import oldStyles from './indexOld.module.scss';
import stylesForLeftNavResize from './index.module.scss';

const styles = isFeatureEnabled(Features.LeftNavResize) ? stylesForLeftNavResize : oldStyles;

interface IOptionRequiredProps {
  href: string;
  children: ReactNode;
}

interface IOptionOptionalProps {
  disabled: boolean;
  locked: boolean;
  className: string;
  disabledByAccessPermission: boolean;
}

interface IOptionProps
  extends IOptionRequiredProps,
  IOptionOptionalProps {
  }

const defaultProps: IOptionOptionalProps = {
  disabled: false,
  locked: false,
  className: '',
  disabledByAccessPermission: false
};

const Option = (props: IOptionProps): JSX.Element => {
  const { href, className, disabled, locked, children, disabledByAccessPermission } = props;
  if (disabledByAccessPermission) {
    return <Tooltip
      placement="right"
      overlayClassName={styles.tooltipOverlay}
      title={tooltipMessage}
    >
      <div className={cx(styles.option, className, styles.disabledByAccessPermission)}>
        <div className={styles.label}><div className={styles.labelAndIcon}>{children}</div> <LockIcon/></div>
      </div>
    </Tooltip>;
  }
  if (disabled) {
    return <Tooltip
      placement="right"
      overlayClassName={styles.tooltipOverlay}
      title={locked ? UpgradeTooltipText() : LapsedTooltipText()}
    >
      <div className={cx(styles.option, className, styles.disabled)}>
        <div className={styles.label}>{children} <LockIcon/></div>
      </div>
    </Tooltip>;
  }

  return <a href={href} className={cx(styles.option, className)}>
    <div className={styles.label}>{children}</div>
  </a>;
};

Option.defaultProps = defaultProps;

export default Option;